import { combineReducers } from "redux";
import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import createStore from "APP_ROOT/createStore";
import { ID } from "APP_ROOT/constants";

export const salesOrdersPagination = createPaginatedList({
  listId: "salesOrders/search",
  fetch: api.salesOrders.search,
  stateLocator: state => state.salesOrders.search,
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
});

export const reservedForSaleInventory = createPaginatedList({
  listId: "reservedForSaleInventory",
  fetch: api.inventories.searchReservedForSale
});

export const salesOrderLineItemsPagination = createPaginatedList({
  listId: "salesOrders/lineItems",
  stateLocator: state => state.salesOrders.lineItems,
  initialSettings: {
    pageSize: 15,
    sort: "cancelled",
    sortReverse: true
  },
  fetch: search => {
    const id = createStore()
      .getState()
      .salesOrderDetail.getIn(["salesOrder", ID]);
    return api.salesOrders.lineItems.search(id, search);
  }
});

export default combineReducers({
  search: salesOrdersPagination.paginator,
  lineItems: salesOrderLineItemsPagination.paginator
});



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/pagination.js